import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { OrderedMap } from "immutable";

import MergeTagsSelection from "settings/components/MergeTagsSelection";
import MergeTagsConfirmation from "settings/components/MergeTagsConfirmation";

import { mergeTagsAsync } from "settings/actions/tags";
import { setMessage } from "actions/message";

class MergeTags extends React.Component {
  constructor(props) {
    super(props);
    this.tags = props.tags
      .toArray()
      .filter(tag => this.props.selectedTags[tag.id]);

    this.selectTagToMerge = this._selectTagToMerge.bind(this);
    this.mergeTags = this._mergeTags.bind(this);
    this.goBack = this._goBack.bind(this);
    this.onChange = this._onChange.bind(this);

    this.state = {
      wasClicked: false,
      step: "selection",
    };
  }

  _selectTagToMerge() {
    if (this.state.selectedTag) {
      if (this.state.error) {
        this.setState({ error: "" });
      }
      this.setState({ step: "confirmation" });
    } else {
      this.setState({ error: "Please select a tag" });
    }
  }

  _mergeTags() {
    this.setState({ wasClicked: true });
    const tagsToDelete = this.tags.filter(
      tag => tag.id !== this.state.selectedTag.value
    );
    return this.props
      .mergeTagsAsync(this.state.selectedTag.value, tagsToDelete)
      .then(() => {
        this.props.history.push("/settings/tags");
        this.props.setMessage({
          message: `The selected tags have been merged into "${this.state.selectedTag.name}"`,
          type: "success",
        });
      })
      .catch(error => {
        this.props.setMessage({ message: error });
        this.setState({ wasClicked: false });
      });
  }

  _onChange(tag) {
    this.setState({ selectedTag: tag });
  }

  _goBack() {
    this.setState({ step: "selection" });
  }

  render() {
    const sharedProps = {
      tags: this.tags,
      selectedTag: this.state.selectedTag,
      error: this.state.error,
      wasClicked: this.state.wasClicked,
    };

    if (this.state.step === "selection") {
      return (
        <MergeTagsSelection
          onChange={this.onChange}
          onClick={this.selectTagToMerge}
          {...sharedProps}
        />
      );
    } else if (this.state.step === "confirmation") {
      return (
        <MergeTagsConfirmation
          onClick={this.mergeTags}
          onCancel={this.goBack}
          {...sharedProps}
        />
      );
    }
  }
}

const mapStateToProps = state => ({
  tags: state.settings.tags.tags,
  selectedTags: state.settings.tags.selected,
});

const mapDispatchToProps = {
  mergeTagsAsync,
  setMessage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MergeTags);

MergeTags.propTypes = {
  mergeTagsAsync: PropTypes.func.isRequired,
  setMessage: PropTypes.func.isRequired,
  selectedTags: PropTypes.object.isRequired,
  tags: PropTypes.instanceOf(OrderedMap),
};
